query MobileDashboardAllIssues(
	$offset: Int!
	$limit: Int!
	$sort: issuesSort
	$daysFilter: ConditionInt
	$severityFilter: ConditionString
	$issueTypeFilter: ConditionString
	$appIdFilter: ConditionString
	$textSearch: issuesSearchInsensitive
	$customFieldsFilter: ConditionStringArray
) {
	issues(
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysFilter
		severity_name_eq: $severityFilter
		type_name_eq: $issueTypeFilter
		app_id_eq: $appIdFilter
		text_contains: $textSearch
		mobile_kit_eq: { value: true }
		deleted_eq: { value: false }
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		issue_id
		run_id
		product_name
		type_name
		severity_name
		scan_name
		app_id
		session_name
	}
	total: issues(
		run_time_last_n_days: $daysFilter
		severity_name_eq: $severityFilter
		type_name_eq: $issueTypeFilter
		app_id_eq: $appIdFilter
		text_contains: $textSearch
		mobile_kit_eq: { value: true }
		deleted_eq: { value: false }
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		issue_id_count
	}
	unfilteredTotal: issues(
		mobile_kit_eq: { value: true }
		deleted_eq: { value: false }
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
	) {
		issue_id_count
	}
}
